import { v4 as uuidv4 } from 'uuid';

/** Walk sections and find Assignment nodes inserted by AI that still need drafts. */
export function collectAiAssignmentSlots(sections) {
  const slots = [];
  (sections || []).forEach((section, sectionIndex) => {
    (section.subsections || []).forEach((subsection, subsectionIndex) => {
      (subsection.nestedSections || []).forEach((nested, nestedIndex) => {
        if (nested.type !== 'Assignment') return;
        const hasLinked = nested.assignments?.length > 0 && nested.assignments[0]?.questions?.length;
        if (hasLinked) return;
        const summary = nested.ai_assignment_summary || nested.text || nested.title;
        if (!summary) return;
        slots.push({
          sectionIndex,
          subsectionIndex,
          nestedIndex,
          componentId: nested.id,
          title: nested.text || nested.title || 'Untitled Assignment',
          summary,
          lessonTitle: subsection.text || subsection.title,
          moduleTitle: section.text || section.title,
        });
      });
    });
  });
  return slots;
}

export function draftResponseToAssignmentRecord(draftResponse, { title, pathwayId, componentTaxonomy }) {
  const { draft } = draftResponse || {};
  if (!draft) return null;

  const newId = uuidv4();
  const taxonomy =
    (draft.taxonomy || []).filter((t) => t.taxonomy_id).length > 0
      ? draft.taxonomy.filter((t) => t.taxonomy_id)
      : componentTaxonomy || [];

  return {
    id: newId,
    title: draft.title || title,
    gradingresulttype: draft.gradingresulttype || 'Points',
    initialdirections: (draft.initialdirections || []).map((d) => ({ ...d, _id: uuidv4() })),
    questions: (draft.questions || []).map((q) => ({ ...q, _id: uuidv4() })),
    hours: draft.hours ?? 1,
    maxpoints: draft.maxpoints ?? null,
    concentration: pathwayId || draft.concentration || null,
    otherconcentrations: draft.otherconcentrations || [],
    taxonomy,
  };
}

export function applyAssignmentToSlot(sections, slot, assignmentRecord) {
  const next = sections.map((section, si) => {
    if (si !== slot.sectionIndex) return section;
    return {
      ...section,
      subsections: section.subsections.map((subsection, sji) => {
        if (sji !== slot.subsectionIndex) return subsection;
        return {
          ...subsection,
          nestedSections: subsection.nestedSections.map((nested, ni) => {
            if (ni !== slot.nestedIndex) return nested;
            return {
              ...nested,
              assignments: [assignmentRecord],
              assignmentData: { ...assignmentRecord, original: assignmentRecord.id },
              reference_table: 'assignments',
              reference_id: null,
              ai_assignment_summary: undefined,
              hasChanges: true,
              hours: assignmentRecord.hours,
              taxonomy: assignmentRecord.taxonomy?.length
                ? assignmentRecord.taxonomy
                : nested.taxonomy,
              primaryConcentration:
                nested.primaryConcentration || assignmentRecord.concentration || '',
            };
          }),
        };
      }),
    };
  });
  return next;
}
